module.exports = __webpack_public_path__ + "img/IMG_3539_L_Black_MockedUp.6d241dc9.jpg";